import { render } from "./TourShowComponent.vue?vue&type=template&id=36a14f96"
import script from "./TourShowComponent.vue?vue&type=script&lang=js"
export * from "./TourShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__